import React from "react";

import { Button, Label, Link } from "lib/components/vendor";
import CSSModules from "lib/utils/css-modules";
import { bindActionCreators } from "redux";
import st from "lib/utils/index";
import styles from "./ProductsListItem.less";
import * as FormControl from "lib/components/FormControl";
import { connect } from "react-redux";
import { RAILS_PUBLIC_URL } from "config/globals";
import PriorityRepository from "lib/repositories/PriorityRepository";
import fetch from "modules/products/utils";

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        fetch,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class ProductsListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = { product: props.product };
    this.updateStar.bind(this);
    this.redirectForRole.bind(this);
    this.stopPropagationOnClick.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.product !== this.props.product) {
      this.setState({ product: this.props.product });
    }
  }
  updateStar(value) {
    PriorityRepository.updateProductPriority(this.props.product.id, value);
    this.setState((prevState) => ({
      ...prevState,
      product: { ...prevState.product, priority: value },
    }));
  }

  redirectForRole = () => {
    if (st.authorize.company.is_st) {
      let url = `//${window.location.host}/c/${this.state.product.company.id}/products/${this.state.product.id}/edit`;
      window.location.href = url;
      return;
    }
    if (this.state.product.company.id == st.authorize.company.id) {
      let url = `//${window.location.host}/c/${st.authorize.company.id}/products/${this.state.product.id}/edit`;

      window.location.href = url;
    } else {
      this.props.onNewOrderClick();
    }
  };

  stopPropagationOnClick = (e) => {
    e.stopPropagation();
  };

  getHref = () => {
    if (st.authorize.company.is_st) {
      let url = `//${window.location.host}/c/${this.state.product.company.id}/products/${this.state.product.id}/edit`;
      return url;
    }
    if (this.state.product.company.id == st.authorize.company.id) {
      let url = `//${window.location.host}/c/${st.authorize.company.id}/products/${this.state.product.id}/edit`;
      return url;
    }
  };

  render() {
    const { onPropChange, onNewOrderClick, pushCompanyRoute, currentCompany } = this.props;

    const getUrl = () => {};
    const { product } = this.state;
    const isAccommodation = product.product_type === "accommodation";

    const isStAgent = st.authorize.company.is_st;
    const isAgent = !st.authorize.company.is_st && st.authorize.company.agent && !st.authorize.company.supplier;
    const isAgentAndSupplier =
      !st.authorize.company.is_st && st.authorize.company.agent && st.authorize.company.supplier;
    const itemUrl = this.props.product.getPreviewUrlFor(currentCompany);

    let productImageUrl = st.getAttachmentImageUrl(product, "main_image", "thumb");
    if (productImageUrl.endsWith(".webp")) {
      productImageUrl = product.main_image_file.url;
    }

    return (
      <div onClick={this.redirectForRole} styleName="item">
        <div styleName="item-image">
          <img src={productImageUrl} />
        </div>

        <div styleName="item-content">
          <div styleName="item-title-product-name">
            <span>{`ID: ${product.id} | `}</span>
            {st.authorize.company.is_st || this.state.product.company.id == st.authorize.company.id ? (
              <a href={this.getHref()}>
                <strong style={{ color: "#000" }}>{product.supplier_name}:</strong> {product.name}
              </a>
            ) : (
              <a onClick={this.redirectForRole}>
                <strong style={{ color: "#000" }}>{product.supplier_name}:</strong> {product.name}
              </a>
            )}

            <FormControl.Star
              value={product.priority}
              onChange={(priority) => this.updateStar(priority)}
              alternative={isStAgent}
            />
          </div>
          {product.product_variants.length > 1 && (
            <div styleName="item-title-product-variant-name">
              <ul>
                {product.product_variants.map((pv) => (
                  <li key={pv.uuid}>{pv.name}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div styleName="item-switches">
        {st.authorize("update", product) && (
            <FormControl.CheckboxFormGroup
              checked={product.active}
              onChange={checked =>
                onPropChange("status", checked ? "published" : "draft")
              }
              label={I18n.t(
                "papp.components.ProductsListItem.active_switch_label"
              )}
              toggle
            />
          )}

          {st.authorize("update", product) && product.company.enable_saas && (
            <FormControl.CheckboxFormGroup
              checked={product.active && product.published_on_saas}
              onChange={checked => onPropChange("published_on_saas", checked)}
              label={I18n.t(
                "papp.components.ProductsListItem.published_on_saas_switch_label"
              )}
              toggle
              disabled={!product.active}
              wrapperClassName="u-marginTop"
            />
          )}
          {/* <span
            style={{ color: product.status === "published" ? "#38aa82" : "grey" }}
            styleName={product.status === "published" ? "published" : "unpublished"}
          >
            <Label empty circular />
            {I18n.t(product.status === "published" ? "attributes.published" : "attributes.draft")}
          </span>

          {product.status === "published" && currentCompany.enable_saas && (
            <span
              style={{ color: product.published_on_saas ? "#38aa82" : "grey" }}
              styleName={product.published_on_saas ? "published" : "unpublished"}
            >
              <Label empty circular />
              {I18n.t(product.published_on_saas ? "attributes.active_www" : "attributes.inactive_www")}
            </span>
          )} */}
        </div>

        <div styleName="item-buttons">
          <div styleName="buttons">
            {product.connectly_source_name && (
              <Button
                color="yellow"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  pushCompanyRoute(`/products/${product.id}/edit?step=integrations`);
                }}
                content={product.connectly_source_name}
              />
            )}
            {(st.authorize.company.is_st || this.state.product.company.id == st.authorize.company.id) && (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  pushCompanyRoute(`/products/${product.id}/edit?step=availability`);
                }}
                icon={<i className="icon material-icons">date_range</i>}
              />
            )}
            <Button
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();

                window.location = `${RAILS_PUBLIC_URL}/api/public/products/${product.id}/pdf?locale=${I18n.locale}`;
              }}
              icon={<i className="icon material-icons">print</i>}
            />

            {itemUrl && (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  Object.assign(document.createElement("a"), { target: "_blank", href: itemUrl }).click();
                }}
                icon={<i className="icon material-icons">remove_red_eye</i>}
              />
            )}

            {!isAccommodation &&
              product.status === "published" &&
              (st.authorize.company.enable_saas || st.authorize.company.is_st) && (
                <Button
                  primary
                  className={
                    product.status === "published" && (st.authorize.company.enable_saas || st.authorize.company.is_st)
                      ? undefined
                      : "u-visibilityHidden"
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onNewOrderClick();
                  }}
                  content={I18n.t("papp.components.ProductsListItem.new_order")}
                />
              )}
          </div>
        </div>

        <div styleName="item-read-more-button">
          {!currentCompany.reseller && (
            <a href="#">
              <i className="icon material-icons">chevron_right</i>
            </a>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/list/ProductsListItem.jsx